import { QuotationServiceCampaignModel } from './quotationCampaign.model';
import { QuotationPartVOs } from './quotationPartVO.model';

export interface IQuotationVOs {
  campaigns: QuotationServiceCampaignModel[];
  serviceId: number;
  service: string;
  isPickupDelivery: boolean;
  isInitialQuotation: string;
  isApproved: string;
  dmsCode: string | null;
  price: number;
  costless: boolean;
  quotationPartVOs? : QuotationPartVOs[];
  reviewService?: string;
  reviewTMA?: string;
  costLabor?: number;
  discount?: number;
  isPromotion?: boolean;
  originalPrice?: number;
}
